<div class="container dasboard">
  <label class="title-dashboard text-center w-100 pb-4">CÁC BỘ TỪ VỰNG NHỊ NGỮ - BILET</label>
  <app-book [listBook]="listBook"></app-book>
</div>